<script>
export default {
  data() {
    return {
      apiFailureAlertProps: [
        {
          mode: 'alert',
          type: 'warning',
          text: 'API request failed. Please try refreshing the page.',
          color: 'error',
          dismissible: false,
        },
      ],
    }
  },
  computed: {
    getErrorText() {
      const alert = {
        mode: 'alert',
        multiLine: true,
        type: 'warning',
        text: 'API request failed. Please try refreshing the page.',
        color: 'error',
        dismissible: true,
        isActive: true,
      }
      const errors = this.apiPageFailure.filter(failure => !failure.url)
      let apiFailures = ''
      if (errors.length === 1) apiFailures = errors[0]
      else if (errors.length === 2) apiFailures = errors.join(' and ')
      else if (errors.length >= 3)
        apiFailures = `${errors.slice(0, -1).join(', ')} and ${errors.slice(
          -1,
        )}`
      if (apiFailures.length) {
        alert.text = `Unable to retrieve ${apiFailures} data at this time. Please try again later.`
      }
      return [alert]
    },
  },
}
</script>
